import React from 'react';

/**
 * PrintableStaffList Component
 * Hidden on screen, only visible when printing
 * Professional layout for office staff directory
 */
const PrintableStaffList = ({ staffData, providerInfo }) => {
  if (!staffData || staffData.length === 0) return null;

  return (
    <div id="printable-staff-list" className="print-only">
      {/* Header Section */}
      <div className="print-header">
        <div className="print-logo-section">
          <img
            src="/logo512.png"
            alt="RepConnect"
            className="print-logo-image"
          />
          <div className="print-brand-name">RepConnect</div>
          <div className="print-website">www.meetwithreps.com</div>
        </div>

        <div className="print-title-section">
          <h1>OFFICE STAFF DIRECTORY</h1>
        </div>
      </div>

      {/* Provider Information Section */}
      {providerInfo && (
        <div className="print-meeting-info">
          <div className="print-info-grid">
            <div className="print-info-item">
              <span className="print-label">Practice:</span>
              <span className="print-value">{providerInfo.name}</span>
            </div>
            {providerInfo.company && (
              <div className="print-info-item">
                <span className="print-label">Company:</span>
                <span className="print-value">{providerInfo.company}</span>
              </div>
            )}
            {providerInfo.npi && (
              <div className="print-info-item">
                <span className="print-label">NPI:</span>
                <span className="print-value">{providerInfo.npi}</span>
              </div>
            )}
            {providerInfo.location && (
              <div className="print-info-item">
                <span className="print-label">Location:</span>
                <span className="print-value">{providerInfo.location}</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Staff List Section */}
      <div className="print-section">
        <h2 className="print-section-title">Office Staff ({staffData.length})</h2>
        <div className="print-separator-line"></div>

        {staffData.map((staff, index) => (
          <div key={staff.id} className="print-attendee-row">
            <div className="print-attendee-number">{index + 1}.</div>
            <div className="print-attendee-info">
              <span className="print-attendee-name">{staff.name}</span>
              <span className="print-attendee-role">{staff.role || 'Team Member'}</span>
              {staff.email && (
                <span className="print-contact-detail-inline" style={{ marginTop: '2px' }}>
                  {staff.email}
                </span>
              )}
              {staff.phone && (
                <span className="print-contact-detail-inline">
                  {staff.phone}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Footer with total count and timestamp */}
      <div className="print-footer">
        <div className="print-separator-line"></div>
        <div className="print-footer-content">
          <div>
            <strong>Total Staff Members:</strong> {staffData.length}
          </div>
          <div className="print-generated-date">
            Generated: {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintableStaffList;
